// copied from @powerpoint-webcomponents\ppt-speech-client\lib\src\ILogger.d.ts
export var TraceLevel;
(function (TraceLevel) {
    /**
     * Error handling code paths, almost always unexpected, generally unrecoverable.
     * aka Unexpected
     */
    TraceLevel[TraceLevel["Error"] = 10] = "Error";
    /**
     * Generally used for error-handling code paths that are occasionally expected
     * and/or usually handled appropriately.
     * aka Monitorable
     */
    TraceLevel[TraceLevel["Warning"] = 15] = "Warning";
    /**
     * Normal/expected code paths, used to indicate the "big" things that
     * are happening (e.g. activation, status updates).
     * aka Medium
     */
    TraceLevel[TraceLevel["Info"] = 50] = "Info";
    /**
     * Intended only for developers/testers for the purposes of debugging issues.
     */
    TraceLevel[TraceLevel["Verbose"] = 100] = "Verbose";
    /**
     * Generally not used, but expected to cause significant slow down (when on) and
     * significantly increase log size. Used only for debugging issues that are very
     * difficult to track down.
     * aka VerboseEx
     */
    TraceLevel[TraceLevel["Spam"] = 200] = "Spam";
})(TraceLevel || (TraceLevel = {}));
// copied from @powerpoint-webcomponents\ppt-speech-client\lib\src\SpeechClientInterfaces.d.ts
export var ClientApp;
(function (ClientApp) {
    ClientApp[ClientApp["PowerPoint"] = 0] = "PowerPoint";
    ClientApp[ClientApp["Word"] = 1] = "Word";
    ClientApp[ClientApp["OneNote"] = 2] = "OneNote";
    ClientApp[ClientApp["Outlook"] = 3] = "Outlook";
    ClientApp[ClientApp["Unknown"] = 4] = "Unknown";
    ClientApp[ClientApp["LinkedIn"] = 5] = "LinkedIn";
    ClientApp[ClientApp["Flipgrid"] = 6] = "Flipgrid";
    ClientApp[ClientApp["OfficeMobie"] = 7] = "OfficeMobie";
    ClientApp[ClientApp["OfficeSuite"] = 8] = "OfficeSuite";
    ClientApp[ClientApp["Teams"] = 9] = "Teams";
})(ClientApp || (ClientApp = {}));
// List of specific errrors from service.This is not an exhaustive list of errors
export var ISpeechError;
(function (ISpeechError) {
    ISpeechError["ErrorNone"] = "ErrorNone";
    ISpeechError["ErrorInvalidSubscriptionFromConfig"] = "ErrorInvalidSubscriptionFromConfig";
    ISpeechError["ErrorInvalidRegionFromConfig"] = "ErrorInvalidRegionFromConfig";
    ISpeechError["ErrorAddSessionFailure"] = "ErrorAddSessionFailure";
    ISpeechError["ErrorCreateSpeechSessionBadRequest"] = "ErrorCreateSpeechSessionBadRequest";
    ISpeechError["ErrorSpeechHandlerWebSocketFailure"] = "ErrorSpeechHandlerWebSocketFailure";
    ISpeechError["ErrorInvalidMessage"] = "ErrorInvalidMessage";
    ISpeechError["ErrorWaitAudioTimeout"] = "ErrorWaitAudioTimeout";
    ISpeechError["ErrorInitialSilenceTimeout"] = "ErrorInitialSilenceTimeout";
    ISpeechError["ErrorInitialBabbleTimeout"] = "ErrorInitialBabbleTimeout";
    ISpeechError["ErrorProtobufDeserializationFailure"] = "ErrorProtobufDeserializationFailure";
    ISpeechError["ErrorSpeechRecognitionFailure"] = "ErrorSpeechRecognitionFailure";
    ISpeechError["ErrorTranslationFailure"] = "ErrorTranslationFailure";
    ISpeechError["ErrorFailedToGetSupportedTextLanguages"] = "ErrorFailedToGetSupportedTextLanguages";
    ISpeechError["ErrorCustomEndpointTimeout"] = "ErrorCustomEndpointTimeout";
    ISpeechError["ErrorAudioAbortError"] = "ErrorAudioAbortError";
    ISpeechError["ErrorAudioNotAllowedError"] = "ErrorAudioNotAllowedError";
    ISpeechError["ErrorAudioNotFoundError"] = "ErrorAudioNotFoundError";
    ISpeechError["ErrorAudioNotReadableError"] = "ErrorAudioNotReadableError";
    ISpeechError["ErrorAudioOverconstrainedError"] = "ErrorAudioOverconstrainedError";
    ISpeechError["ErrorAudioSecurityError"] = "ErrorAudioSecurityError";
    ISpeechError["ErrorAudioTypeError"] = "ErrorAudioTypeError";
    ISpeechError["ErrorAudioSetupFailure"] = "ErrorAudioSetupFailure";
    ISpeechError["ErrorAudioCaptureStalePermission"] = "ErrorAudioCaptureStalePermission";
    ISpeechError["ErrorConnectionRetryFailure"] = "ErrorConnectionRetryFailure";
    ISpeechError["ErrorWebcamSamplingUnsupportedSpeechMode"] = "ErrorWebcamSamplingUnsupportedSpeechMode";
    ISpeechError["ErrorWebcamSetupFailure"] = "ErrorWebcamSetupFailure";
    ISpeechError["ErrorWebcamNotFoundError"] = "ErrorWebcamNotFoundError";
    ISpeechError["ErrorMultipleWebcamsFound"] = "ErrorMultipleWebcamsFound";
    ISpeechError["ErrorMaxConnectionRetryFailureInSession"] = "ErrorMaxConnectionRetryFailureInSession";
    ISpeechError["ErrorUnknown"] = "ErrorUnknown";
})(ISpeechError || (ISpeechError = {}));
// copied from @powerpoint-webcomponents\ppt-speech-client\lib\src\SpeechClientInterfaces.d.ts
export var IEventName;
(function (IEventName) {
    IEventName["RehearsalDashboardUpdate"] = "RehearsalDashboardUpdate";
    IEventName["MediaEvent"] = "MediaEvent";
    IEventName["QualityStatusUpdate"] = "QualityStatusUpdate";
    IEventName["ConnectionRetry"] = "ConnectionRetry";
})(IEventName || (IEventName = {}));
export var QualityStatusCode;
(function (QualityStatusCode) {
    QualityStatusCode[QualityStatusCode["None"] = 0] = "None";
    QualityStatusCode[QualityStatusCode["Listening"] = 1] = "Listening";
    QualityStatusCode[QualityStatusCode["Warning_CannotHearYou"] = 2] = "Warning_CannotHearYou";
    QualityStatusCode[QualityStatusCode["Warning_BackgroundNoise"] = 3] = "Warning_BackgroundNoise";
    QualityStatusCode[QualityStatusCode["Warning_TooLoud"] = 4] = "Warning_TooLoud";
    QualityStatusCode[QualityStatusCode["Warning_TooQuiet"] = 5] = "Warning_TooQuiet";
    QualityStatusCode[QualityStatusCode["Warning_WeakConnection"] = 6] = "Warning_WeakConnection";
    QualityStatusCode[QualityStatusCode["Warning_SlowConnection"] = 7] = "Warning_SlowConnection";
    QualityStatusCode[QualityStatusCode["Warning_UnstableConnection"] = 8] = "Warning_UnstableConnection";
    QualityStatusCode[QualityStatusCode["Warning_ServiceIssue"] = 9] = "Warning_ServiceIssue";
    QualityStatusCode[QualityStatusCode["Error_CannotHearYou"] = 10] = "Error_CannotHearYou";
    QualityStatusCode[QualityStatusCode["Error_BackgroundNoise"] = 11] = "Error_BackgroundNoise";
    QualityStatusCode[QualityStatusCode["Error_TooLoud"] = 12] = "Error_TooLoud";
    QualityStatusCode[QualityStatusCode["Error_TooQuiet"] = 13] = "Error_TooQuiet";
    QualityStatusCode[QualityStatusCode["Error_WeakConnection"] = 14] = "Error_WeakConnection";
    QualityStatusCode[QualityStatusCode["Error_SlowConnection"] = 15] = "Error_SlowConnection";
    QualityStatusCode[QualityStatusCode["Error_UnstableConnection"] = 16] = "Error_UnstableConnection";
    QualityStatusCode[QualityStatusCode["Error_ServiceIssue"] = 17] = "Error_ServiceIssue";
})(QualityStatusCode || (QualityStatusCode = {}));
var WebSocketState;
(function (WebSocketState) {
    WebSocketState["Closed"] = "Closed";
    WebSocketState["Closing"] = "Closing";
    WebSocketState["Connecting"] = "Connecting";
    WebSocketState["Open"] = "Open";
})(WebSocketState || (WebSocketState = {}));
//# sourceMappingURL=speechClientInterface.js.map